import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import { PlayerNotifyComponent } from '@splixer/player-ui';
import { RouterOutlet } from '@angular/router';
import {SplixerLayoutControlService, StationManagerService} from "@splixer/player";
import {NgClass} from "@angular/common";
import {KnhcHeaderComponent} from "../../../core/layout/header/knhc-header.component";
import { KnhcFooterComponent } from '../../../core/layout/footer/knhc-footer.component';

@Component({
  selector: 'knhc-root-page',
  templateUrl: 'root.page.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PlayerNotifyComponent,
    RouterOutlet,
    NgClass,
    KnhcHeaderComponent,
    KnhcFooterComponent
  ]
})
export class KnhcRootPage {
  protected layoutController = inject(SplixerLayoutControlService);
  protected station = inject(StationManagerService);

}
